import { render } from "./MetaInfoSection.vue?vue&type=template&id=6d9f31ef&scoped=true"
import script from "./MetaInfoSection.vue?vue&type=script&lang=js"
export * from "./MetaInfoSection.vue?vue&type=script&lang=js"

import "./MetaInfoSection.vue?vue&type=style&index=0&id=6d9f31ef&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\stani\\OneDrive\\Documents\\Git\\fate-extended\\node_modules\\.pnpm\\vue-loader@17.0.1_vue@3.2.45+webpack@5.75.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d9f31ef"]])

export default __exports__